import React, { useState } from 'react';
import CustomButton from '../CustomButton';
import { translate } from '../../services/translate';
import { dispatchService } from '../../services/central-api/dispatch';
import Toast from 'react-native-toast-message';
import { ClientError } from '../../services/central-api/base-service';
import { openExternalLinkInNewTab } from '../../services/navigation-assistant';

interface Props {
    occurrence: Occurrence;
}

function ExportPDFOccurrenceDetails({ occurrence }: Props) {
    const [loading, setIsLoading] = useState(false);

    async function downloadPdf() {
        if (!occurrence.signableReport) {
            return;
        }
        try {
            setIsLoading(true);
            const signableReport = await dispatchService.getSignableReport(occurrence.signableReport.id);
            openExternalLinkInNewTab(signableReport.resultUrl);
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }

            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <CustomButton
            text={translate('downloadReport')}
            onPress={() => downloadPdf()}
            style={{ minWidth: 158 }}
            type='secondary'
            isLoading={loading}
        />
    );
}

export default ExportPDFOccurrenceDetails;
